/**
 * This is a type-safe replacement for `Object.keys`. The generated keys array contains the keys of the given object, while the type of the `Object.keys` array elements is just strings.
 */
export const objectKeys = (obj) => Object.keys(obj);
